import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

export const buttonVariants = cva(
  cn(
    'eye:button eye:inline-flex eye:w-auto eye:cursor-pointer eye:items-center',
    'eye:justify-center eye:gap-4xs eye:rounded-full eye:whitespace-nowrap',
    'eye:outline-offset-3 eye:outline-black eye:transition-[color]',
    'eye:focus-visible:outline-2 eye:active:outline-2 eye:disabled:cursor-not-allowed eye:disabled:bg-grey-disabled eye:disabled:text-grey-disabled eye:disabled:outline-none eye:disabled:focus-visible:outline-none',
    'eye:[&_svg]:pointer-events-none eye:[&_svg]:shrink-0 eye:[&_svg:not([class*=size-])]:size-[20px]',
  ),
  {
    variants: {
      variant: {
        black: 'eye:bg-black eye:text-white eye:hover:bg-grey-hover',
        yellow: 'eye:bg-yellow-100 eye:hover:bg-yellow-hover',
        ghost: 'eye:bg-transparent eye:text-black eye:hover:bg-grey-20',
        outline:
          'eye:border-2 eye:focus-visible:border-grey-120 eye:focus-visible:text-grey-120 eye:not-disabled:hover:border-grey-120 eye:not-disabled:hover:text-grey-120 eye:disabled:bg-transparent',
      },
      size: {
        default: 'eye:h-[44px] eye:px-20',
        sm: 'eye:h-[35px] eye:px-16',
        icon: 'eye:h-32! eye:min-w-32 eye:p-5xs',
      },
    },
    defaultVariants: {
      variant: 'black',
      size: 'default',
    },
  },
);
